// /* eslint-disable react/prop-types */
import * as React from 'react';
import { Grid, FormGroup, FormControlLabel, Typography, Radio } from '@mui/material';
import PropTypes from 'prop-types';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';

export default function SpaceDimensionsCheckBoxes({
  spaceDimensions,
  handleChange,
  selectedSpaceDimension,
}) {
  function isChecked(spaceDimension) {
    return selectedSpaceDimension?.id === spaceDimension.id;
  }

  return (
    <FormGroup>
      <Grid container justifyContent="space-between">
        <Grid item sx={{ width: '163px' }}>
          <Typography>Size</Typography>
        </Grid>
        <Grid item>
          <Typography>Industry</Typography>
        </Grid>
        <Grid item>
          <Typography>Budget</Typography>
        </Grid>
      </Grid>
      {spaceDimensions.map(
        (spaceDimension) =>
          spaceDimension.status === AMENITY_SPACE_STATUS.ENABLED && (
            <div key={spaceDimension.id}>
              <Grid container justifyContent="space-between">
                <Grid item>
                  <FormControlLabel
                    control={
                      <Radio
                        id={spaceDimension.id.toString()}
                        checked={isChecked(spaceDimension)}
                        onChange={handleChange}
                      />
                    }
                    label={`Size ${spaceDimension.size} - ${spaceDimension.space_number} Space`}
                  />
                </Grid>
                <Grid item>
                  <Typography color="#0997BA">{spaceDimension.industry}</Typography>
                </Grid>
                <Grid item>
                  <Typography color="#0997BA">$ {spaceDimension.cost} USD</Typography>
                </Grid>
              </Grid>
            </div>
          ),
      )}
    </FormGroup>
  );
}

SpaceDimensionsCheckBoxes.propTypes = {
  spaceDimensions: PropTypes.instanceOf(Array),
  selectedSpaceDimension: PropTypes.instanceOf(Object),
  handleChange: PropTypes.func,
};

SpaceDimensionsCheckBoxes.defaultProps = {
  spaceDimensions: [],
  selectedSpaceDimension: {},
  handleChange: () => {},
};
